angular.module('app.directives', [])  

  .directive('scrollPage', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      element.on 'click', (e) ->
        e.preventDefault()
        offset = 0
        scrollPage = new SmoothScroll()
        scrollPage.animateScroll(document.querySelector($(this).attr('href')), 0, {
          updateURL: false
          header: '.header-placeholder'
          offset: offset
          speed: 200
          speedAsDuration: true
        })
  )
  
  .directive('scrollbar', ->
    restrict: 'A'
    link : (scope, element, attrs) ->
      element.scrollbar()
  )

  .directive "compareTo", () ->
    require: "ngModel"
    scope:  
      confirmPassword: "=compareTo"
    link: (scope, element, attributes, modelVal) ->
      modelVal.$validators.compareTo = (val) ->
        return true unless val
        return val == scope.confirmPassword
      scope.$watch "confirmPassword", () ->
        modelVal.$validate()

  .directive 'onErrorSrc', () ->
    return
      link: (scope, element, attrs) ->
        element.bind 'error', () ->
          if (attrs.src != attrs.onErrorSrc)
            attrs.$set('src', attrs.onErrorSrc)
        
  .directive('myEnter', () ->
    return (scope, element, attrs) ->
      element.bind("keydown keypress",  (event) ->
        if (event.which == 13)
          scope.$apply(() ->
            scope.$eval(attrs.myEnter)
          )
          event.preventDefault()        
      )
  )

  .directive "validEmail", () ->
    require: "ngModel"
    scope:  
      email: "=validEmail"
    link: (scope, element, attributes, modelVal) ->
      modelVal.$validators.validEmail = (val) ->
        return false unless val
        return scope.email

      scope.$watch "email", () ->
        modelVal.$validate()


  .directive('paginationFor', ->
    restrict: 'A'
    template: '
      <nav ng-show="table.data.pages > 1">
        <ul class="pagination jc-c gap-12 fw-wrap">
          <li class="page-item" ng-class="{disabled: table.params.page == 1}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page - 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-left"/></svg></a></li>
          <li class="page-item" ng-repeat="page in table.pagination track by $index" ng-class="{active: table.params.page == page, disabled: !page}">
            <a href rel="noffolow" class="page-link" ng-click="table.setPage(page)" ng-show="page">{{ page }}</a>
            <a href rel="noffolow" class="page-link" ng-hide="page">&hellip;</a>
          </li>
          <li class="page-item" ng-class="{disabled: table.params.page == table.data.pages}"><a class="page-link" href rel="noffolow" ng-click="table.setPage(table.params.page + 1)"><svg class="fi fi-16 d-inline-block"><use xlink:href="assets/img/icons/feather-sprite.svg#chevron-right"/></svg></a></li>
        </ul>         
      </nav>'
    replace: true
    scope:
      table: '=paginationFor'
    controller: ['$scope', '$filter', (self, $filter) ->
      return
    ]
  ) 

  .directive('programDays', ->
    restrict: 'A'   
    template: '{{ days }}'
    scope:
      program: '=programDays'
    controller: ['$scope', (self) ->
      self.days = []
      days = ["01.10.2024", "02.10.2024", "03.10.2024", "04.10.2024", "05.10.2024"]
      for i in [1..4]
        self.days.push days[i] if !!self.program?["event_day#{i}"]
      
      self.days = if self.days.length < 4 then self.days.join(", ") else "#{self.days[0]} - #{self.days[3]}"
      return
    ]
  ) 